export enum PrivateMarketplace {
  InHouse = 'InHouse',
  Boost = 'Boost',
}
